module.exports = __webpack_public_path__ + "img/6.23dfd44b.webp";